// src/services/clients.service.js
import api from "@/api/axios";

export async function getClients() {
  const response = await api.get("/clients");
  return response.data;
}